module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./res/accessibility/en_US.json
// module id = 15
// module chunks = 0